import { CircularProgress } from "@stacklet/ui";

import { BackdropFallback } from "./BackdropFallback";

export function CircularFallback() {
  return (
    <BackdropFallback>
      <CircularProgress size="xl" variant="inverted" />
    </BackdropFallback>
  );
}
